export default "__VITE_ASSET__BKJe53nN__"